module.exports = __webpack_public_path__ + "static/img/user_bg.d6322ca2.png";